
export enum headType {
    none = 'none',
    G_M__O_TH2 = 'G-M / O-TH2',
    G_XL__O_TH2 = 'G-XL / O-TH2',
    G_M__O_TLH2 = 'G-M / O-TLH2',
    G_XL__O_TLH2 = 'G-XL / O-TLH2',
    _O_TH2 = 'O-TH2',
    _O_TLH2 = 'O-TLH2',
    _2G_MH = '2G-MH',
    _2G_LH = '2G-LH',
    _2G_M = '2G-M',
    _2G_L = '2G-L'
}